import React, {Fragment} from "react";
import AccountForgotPassword from "../components/account/AccountForgotPassword";
import {NextPage} from "next";
import {domainUrl} from "../helper";
import {useRouter} from "next/router";
import Head from "next/head";
import {TranslationsType} from "../types/homePageTypes";
import MainLayout, {ILayout} from "../components/ForCWV/Wrappers/MainLayout";
import {SignPageTranslations} from "../services/translationKeys";
import {layoutProps} from "../services/layoutProps";

interface IProps extends ILayout {
    translationsData: TranslationsType;
    selectedLocale: string,
    dbName: string
    breadcrumb: Array<{ title: string; url: string }>;
}

const ForgotPassword: NextPage<IProps> = (pageProps) => {
    const {dbName, selectedLocale, translationsData, breadcrumb} = pageProps;
    const router = useRouter()
    const meta_title = translationsData.ForgotPassword
    const meta_description = "Forgot password page"
    const meta_keywords = ""
    const meta_url = domainUrl(`${dbName}${router.locale !== "catchAll" ? "/" + selectedLocale : ""}${router.asPath}`)

    return (
        <MainLayout {...pageProps}>
            <Fragment>
                <Head>
                    <title>{meta_title}</title>
                    <meta name="title" content={meta_title}/>
                    <meta name="description" content={meta_description}/>
                    <meta name="keywords" content={meta_keywords}/>
                    <meta name="generator" content="Zegashop.com"/>
                    <meta name="twitter:description" content={meta_description}/>
                    <meta name="twitter:title" content={meta_title}/>
                    <meta property="og:description" content={meta_description}/>
                    <meta property="og:title" content={meta_title}/>
                    <meta property="og:keywords" content={meta_keywords}/>
                    <meta property="og:url" content={meta_url}/>
                    <meta property="og:locale" content={selectedLocale}/>
                    <link rel="canonical" href={meta_url}/>
                </Head>
                <AccountForgotPassword dbName={dbName} breadcrumb={breadcrumb} translationsData={translationsData}/>
            </Fragment>
        </MainLayout>
    )
}

export async function getServerSideProps({locale, req}: any) {
    const typedReq = req as unknown as {
        m: { [key: string]: any }[],
        defaultDB: { db_name: string },
        assets: { logo_image: string },
        ipv4: string
    }
    const wrapperProps = await layoutProps({
        requestHeaders: req.headers,
        requestDbName: typedReq.defaultDB.db_name,
        requestModels: typedReq.m,
        requestLogo: typedReq.assets.logo_image,
        nextJSLocale: locale,
        translationsObject: SignPageTranslations,
        ipv4: typedReq.ipv4,
    })
    const { maintenanceInfo, suspendStatus, selectedLocale, translationsData: {Home: HomeIntl, ForgotPassword: ForgotPasswordIntl} } = wrapperProps;
    if (String(suspendStatus) === "469") {
        return {
            redirect: { destination: '/suspend', permanent: false },
        }
    }
    if (maintenanceInfo?.is_maintenance_on) {
        return {
            redirect: { destination: '/maintenance', permanent: false },
        }
    }
    const breadcrumb = [
        {title: HomeIntl, url: `/`},
        {title: ForgotPasswordIntl, url: ``}
    ]

    return {
        props: {
            breadcrumb,
            locale: selectedLocale,
            ...wrapperProps,
        },
    };
}

export default ForgotPassword